import { Heading, Text } from "@/design-system";
import { STEPS } from "../constants";

/** Como a indicação vira cliente, em três passos numerados. */
export const PartnerSteps = () => (
  <section
    aria-labelledby="passos-title"
    className="bg-ds-ink-900 py-16 md:py-20"
  >
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 sm:px-6 lg:px-8">
      <Heading level={2} id="passos-title" className="text-ds-on-solid max-w-2xl">
        Como funciona a indicação
      </Heading>
      <ol className="grid gap-6 md:grid-cols-3">
        {STEPS.map((step, index) => (
          <li key={step.title} className="flex flex-col gap-3">
            <span
              aria-hidden="true"
              className="font-ds-display text-ds-brand-500 text-ds-h1 font-bold leading-none"
            >
              {index + 1}
            </span>
            <Heading level={3} className="text-ds-on-solid">
              <span className="sr-only">Passo {index + 1}: </span>
              {step.title}
            </Heading>
            <Text className="text-ds-ink-300">{step.description}</Text>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
